import { useGetStoresInfiniteQuery, useCreateStoreMutation } from "../query/storesQuery";
import { useTranslation } from "react-i18next";
import { RouterButtonLink } from "../components/Button";
import { StoreListPage } from "./components/StoreListPage";

export const StoresView = () => {
  const { t } = useTranslation();
  const { data: storesData, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } = useGetStoresInfiniteQuery();
  const { mutateAsync: createStore, isPending: createLoading } = useCreateStoreMutation();
  const allStores = storesData?.pages.flatMap((page) => page) ?? [];

  return (
    <StoreListPage
      allStores={allStores}
      isLoading={isLoading}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage ?? false}
      isFetchingNextPage={isFetchingNextPage}
      onCreateStore={(data) => createStore(data)}
      createLoading={createLoading}
      headerActions={
        <RouterButtonLink to="/admin/store-copy" $variant="outlined">
          {t("storeCopy.pageTitle")}
        </RouterButtonLink>
      }
    />
  );
};
